export const environment = {
  production: false,
  // apiUrl: 'http://localhost:8000',
  aesKey: 'MyStrong32CharKey@123',
    apiUrl: 'https://dev.awasbandhu.upda.co.in:3012',
};
